module.exports = __webpack_public_path__ + "img/down-concave.c6e5a1c1.svg";